<div
  [ngStyle]="containerStyle"
  class="counter-container bg-white fs-2 font600"
  [class.busy]="busy"
  [attr.aria-busy]="busy ? 'true' : null"
>
  <ion-button class="clear-btn btn" [disabled]="busy" (click)="CallRemoveFunction(item)">
    <ion-icon slot="icon-only" name="remove"></ion-icon>
  </ion-button>
  <ion-label class="black-text-color">{{ quantity }}</ion-label>
  <ion-button class="clear-btn btn" [disabled]="busy" (click)="CallAddFunction(item)">
    <ion-icon name="add" slot="icon-only"></ion-icon>
  </ion-button>
</div>
